/** Shared Outris brand chrome classes — use for page shell, CTAs, tabs, and focus rings. */

export const brandPrimaryBtn =
    'bg-primary text-primary-foreground hover:bg-brand-gold-hover font-medium transition-colors';

export const brandPrimaryBtnMd =
    'px-4 py-2 bg-primary text-primary-foreground hover:bg-brand-gold-hover rounded-lg text-sm font-medium transition-colors';

export const brandPrimaryBtnSm =
    'px-3 py-1.5 text-sm bg-primary text-primary-foreground hover:bg-brand-gold-hover rounded-md font-medium transition-colors';

export const brandGhostBtn =
    'bg-primary/10 text-primary border border-primary/30 hover:bg-primary/20 transition-colors';

export const brandSecondaryBtn =
    'bg-brand-ink text-white hover:bg-neutral-900 dark:bg-white/10 dark:text-foreground dark:hover:bg-white/15 transition-colors';

export const brandSecondaryBtnSm =
    'px-3 py-1.5 text-sm bg-brand-ink text-white hover:bg-neutral-900 dark:bg-white/10 dark:text-foreground dark:hover:bg-white/15 rounded-md font-medium transition-colors';

export const brandOutlineBtn =
    'px-3 py-1.5 text-sm border border-border bg-card text-foreground hover:bg-muted rounded-md font-medium transition-colors';

export const brandIconAccent = 'text-primary';

export const brandIconTile = 'p-2 bg-primary/10 rounded-lg';

export const brandActiveTab =
    'border-primary text-foreground';

export const brandInactiveTab =
    'border-transparent text-muted-foreground hover:text-foreground';

export const brandInputFocus =
    'focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none';

export const brandPageTitle =
    'text-2xl font-bold text-foreground';

export const brandCardAccent =
    'border-t-4 border-t-primary';

export const brandLink =
    'text-primary hover:text-primary/80 hover:underline transition-colors';

/** Category / soft badge (no padding — compose with text size classes). */
export const brandChipMuted =
    'bg-muted text-foreground';

/** Gold-tint chip (no padding — compose with text size). */
export const brandChipBrandSoft =
    'bg-primary/10 text-foreground border border-primary/20';

/** Full neutral pill chip (readable light + dark). */
export const brandChipNeutral =
    'px-2 py-0.5 rounded-full bg-muted text-foreground border border-border text-xs font-medium';

/** Full brand pill chip. */
export const brandChipBrand =
    'px-2 py-0.5 rounded-full bg-primary/15 text-foreground border border-primary/30 text-xs font-medium';

export const brandStatusLive =
    'text-xs font-medium bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 px-2 py-0.5 rounded-full';

export const brandStatusDanger =
    'bg-red-500/15 text-red-700 dark:text-red-400 border border-red-500/30';

export const brandStatusWarning =
    'bg-amber-500/15 text-amber-700 dark:text-amber-400 border border-amber-500/30';

export const brandStatusSuccess =
    'bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30';
